module.exports = __webpack_public_path__ + "img/10.2e494c84.jpg";